export const formatMessageText = (text) => {
	if (!text) return '';
	return text.replace(/<think>[\s\S]*?<\/think>/g, '');
;
};

export const normalizeNewlines = (s = '') => s.replace(/\\n/g, '\n');

export const sanitizeFilename = (s) => {
	return s.replace(/[^a-zA-Z0-9_\-آ-ی ]/g, '').trim().slice(0, 40).replace(/\s+/g, '_');
};

export const timestamp = () => {
	const d = new Date();
	const pad = (n) => String(n).padStart(2, '0');
	return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
};

// export const handleCopy = (text) => navigator.clipboard.writeText(text || '');